import { Container } from ".";
import { BaseResource } from "./base.resource";

export const ManifestAccessLevel = {
  None: 0,
  View: 1 << 0,
  Edit: 1 << 1,
  Delete: 1 << 2,
  Print: 1 << 3,
  ManageContainers: 1 << 4,
  DownloadReport: 1 << 5,
};

export class Manifest extends BaseResource {
  revison: number;
  wasteType: string;
  totalPages: number;
  trackingNumber: string;
  containers: Container[];
  hasContainers: boolean;
  manifestInstructions: ManifestInstruction[];
  shippingDate: Date;
  shipped: boolean;
  emergencyPhone: string;
  generatorCompany: string;
  generatorId: string;
  generatorName: string;
  generatorPhone: string;
  generatorMailingAddress: string;
  generatorSiteAddress: string;
  facilityName: string;
  facilityAddress: string;
  facilityEpaid: string;
  facilityPhone: string;
  transporter1Company: string;
  transporter1Epaid: string;
  transporter2Company: string;
  transporter2Epaid: string;
  transporterName: string;
  transporterDate: Date;
  createdBy: string;
  createdOn: Date;
  updatedBy: string;
  updatedOn: Date;

  constructor(options?: any) {
    super(options);
    // Initialize properties...
  }
  get isBulk(): boolean {
    return this.wasteType === "Bulk";
  }
  get isLabPack(): boolean {
    return this.wasteType === "LabPack";
  }
  get canView(): boolean {
    return (this.accessLevel & ManifestAccessLevel.View) > 0;
  }
  get canEdit(): boolean {
    return (this.accessLevel & ManifestAccessLevel.Edit) > 0;
  }
  get canDelete(): boolean {
    return !this.hasContainers && (this.accessLevel & ManifestAccessLevel.Delete) > 0;
  }
  get canManageContainers(): boolean {
    return (this.accessLevel & ManifestAccessLevel.ManageContainers) > 0;
  }
  get canPrint(): boolean {
    return (this.accessLevel & ManifestAccessLevel.Print) > 0;
  }
  get canDownloadReport(): boolean {
    console.log(this.accessLevel);
    return (this.accessLevel & ManifestAccessLevel.DownloadReport) > 0;
  }
}

export class UnshippedManifest extends BaseResource {
  wasteType: string;
  trackingNumber: string;
  shippingDate: Date;
}

export class ManifestItem {
  pageNo: number;
  hM: string;
  containers: string;
  dotDescription: string;
  containerDetail: string;
  ergNumber: string;
  tsdfDisposalCode: string;
  tsdfProfile: string;
  containersNo: string;
  wasteType: string;
  totalQuantity: string;
  weightUnits: string;
  volume: string;
  volumeUnits: string;
  stateWasteCode: string;
  wasteCode01: string;
  wasteCode02: string;
  wasteCode03: string;
  wasteCode04: string;
  wasteCode05: string;
  handlingInstructions: string;
  get weightUn(): string {
    return this.totalQuantity ? this.totalQuantity + " " + this.weightUnits : "";
  }
  get volumeUn(): string {
    return this.volume ? this.volume + " " + this.volumeUnits : "";
  }
}

export class ManifestInstruction extends BaseResource {
  pageNo: number;
  specialInstructions: string;
  trackingNumber: string;
}

export class ManifestPages {
  pageNo: number;
  lines: ManifestItem[];
}
